<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('privacy') }}
    </h1>
    <span v-if="lang_Mobif == 'arabic'">
      <privacy-arabic/>
    </span>
    <span v-else-if="lang_Mobif == 'malay'">
      <privacy-malay/>
    </span>
    <span v-else-if="lang_Mobif == 'greek'">
      <privacy-greek/>
    </span>
    <span v-else-if="lang_Mobif == 'czech'">
     <privacy-czech/>
    </span>
    <span v-else-if="lang_Mobif == 'bulgarian'">
     <privacy-bulgarian/>
    </span>
    <span v-else-if="lang_Mobif == 'norwegian'">
     <privacy-norwegian/>
    </span>
    <span v-else-if="lang_Mobif == 'slovakia'">
        <privacy-slovakian/>
    </span>
    <span v-else-if="country_Mobif == 'sk' && lang_Mobif == 'english'">
        <privacy-skenglish/>
    </span>
     <span v-else-if="lang_Mobif == 'swedish'">
        <privacy-swedish/>
    </span>
    <span v-else-if="lang_Mobif == 'finnish'">
      <privacy-finnish/>
    </span>
    <span v-else-if="lang_Mobif == 'romanian'">
      <privacy-romanian/>
    </span>
    <span v-else>
      <privacy-english/>
    </span>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from './../PrivacyPolicyEnglish';
import PrivacyPolicyArabic from './../PrivacyPolicyArabic';
import PrivacyPolicyMalay from './../PrivacyPolicyMalay';
import PrivacyPolicyGreek from './../PrivacyPolicyGreek';
import PrivacyPolicyCzech from './../PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import PrivacyPolicySlovakian from './../PrivacyPolicySlovakian';
import PrivacyPolicySKEnglish from './../PrivacyPolicySKEnglish';
import PrivacyPolicySwedish from './../PrivacyPolicySwedish';
import PrivacyPolicyFinnish from './../PrivacyPolicyFinnish';
import PrivacyPolicyRomanian from './../PrivacyPolicyRomanian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_Mobif", "country_Mobif"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-arabic': PrivacyPolicyArabic,
    'privacy-malay': PrivacyPolicyMalay,
    'privacy-greek': PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian,
    'privacy-slovakian': PrivacyPolicySlovakian,
    'privacy-skenglish': PrivacyPolicySKEnglish,
    'privacy-swedish': PrivacyPolicySwedish,
    'privacy-romanian': PrivacyPolicyRomanian,
    'privacy-finnish': PrivacyPolicyFinnish
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/mobiflix/PrivacyPolicy.vue